import { render, staticRenderFns } from "./answerPage.vue?vue&type=template&id=57e02802&scoped=true&"
import script from "./answerPage.vue?vue&type=script&lang=js&"
export * from "./answerPage.vue?vue&type=script&lang=js&"
import style0 from "./answerPage.vue?vue&type=style&index=0&id=57e02802&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e02802",
  null
  
)

export default component.exports